import React from 'react';

const Footer = () => {
    return (
        <>
            {/* <footer class="footer p-10 glass mr-2 ml-2  text-black">
                <div>
                    <div class="form-control w-80">
                        <div class="relative">
                            <h2 className="text-2xl font-bold text-left">Nayeem Hasan</h2>

                            <div class="grid-flow-col gap-4 md:place-self-center md:justify-self-end flex mt-8">
                                <a href='https://www.linkedin.com/in/hasannayeeem/' target='_blank'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 3 24 24"><path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z"/></svg>
                                </a>
                                <a href='https://twitter.com/nayeeemhasan' target='_blank'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="fill-current"><path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"></path></svg>
                                </a>
                                <a href='https://www.youtube.com/channel/UCOesKp540XUTpUyTgFobqgw' target='_blank'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="fill-current"><path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"></path></svg></a>
                                <a href='https://web.facebook.com/hasannayeeem' target='_blank'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="fill-current"><path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"></path></svg></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <span class="footer-title">Services</span>
                    <a href="link link-hover ">Facebook Marketing</a>
                    <a href="link link-hover">Design</a>
                    <a href="link link-hover">Marketing</a>
                    <a href="link link-hover">Advertisement</a>
                </div>
                <div>
                    <span class="footer-title">Company</span>
                    <a href="link link-hover">About us</a>
                    <a href="link link-hover">Contact</a>
                    <a href="link link-hover">Jobs</a>
                    <a href="link link-hover">Press kit</a>
                </div>
                <div>
                        <span className="footer-title opacity-100">Newsletter</span>
                        <div className="form-control lg:w-80">
                            <label className="label">
                                <span className="label-text">Enter your email address</span>
                            </label>
                            <div className="relative">
                                <input type="text" placeholder="username@site.com" className="input input-bordered w-full pr-16" />
                                <button className="btn border-none btn-primary text-white bg-secondary hover:bg-gradient-to-r from-neutral to-secondary absolute top-0 right-0 rounded-l-none">Subscribe</button>
                            </div>
                        </div>
                    </div>
            </footer> */}
            <footer class="footer footer-center p-4 bg-accent text-accent-content">
                <div>
                    <p className="text-left pb-2 mt-2">
                    &copy; {new Date().getFullYear()} - All right reserved By <a href="https://www.linkedin.com/in/hasannayeeem/">Nayeem Hasan</a>
                    </p>
                </div>
            </footer>
        </>
    );
};

export default Footer;